import Vue from 'vue';
import Vuex from 'vuex';

import urlsAPI from '../../config/urlsAPI';
import handlerError from '../../utils/errors';
import { axiosInstance } from '../../main';

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    token: localStorage.getItem('auth_token') || null,
    refreshToken: localStorage.getItem('refresh_token') || null,
    role: localStorage.getItem('role') || null,
  },
  mutations: {
    login(state, response) {
      state.token = response.token;
      state.refreshToken = response.refreshToken;
      state.role = response.role;
    },
    logout(state) {
      state.token = null;
      state.refreshToken = null;
    },
  },
  getters: {
    isLoggedIn(state) {
      return state.token !== null;
    },

    getRole(state) {
      return state.role;
    },

    getToken(state) {
      return state.token;
    },
  },
  actions: {
    login({ commit }, body) {
      return new Promise((resolve, reject) => {
        axiosInstance.post(urlsAPI.authLoginURL, body)
          .then((response) => {
            if (response.data.error) {
              reject(handlerError(response.data.error));
            }

            const { token, refreshToken, role } = response.data;
            localStorage.setItem('auth_token', token);
            localStorage.setItem('refresh_token', refreshToken);
            localStorage.setItem('role', role);

            // set the authorization header after login for axios
            axiosInstance.defaults.headers.Authorization = `Bearer ${token}`;

            commit('login', response.data);

            resolve(response);
          })
          .catch((err) => {
            reject(err);
            return handlerError(err);
          });
      });
    },
    logout({ commit }) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('refresh_token');
      commit('logout');
    },
    refreshToken({ commit }, body) {
      return new Promise((resolve, reject) => {
        axiosInstance.post(urlsAPI.authRenewalURL, body)
          .then((response) => {
            if (response.data.error) {
              localStorage.removeItem('auth_token');
              localStorage.removeItem('refresh_token');
              handlerError(response.data.error);
            } else {
              const { token, refreshToken, role } = response.data;
              localStorage.setItem('auth_token', token);
              localStorage.setItem('refresh_token', refreshToken);
              localStorage.setItem('role', role);

              commit('login', response.data);
            }
            resolve(response);
          })
          .catch((err) => {
            localStorage.removeItem('auth_token');
            localStorage.removeItem('refresh_token');
            reject(err);
            return handlerError(err);
          });
      });
    },
  },
};
